import React from "react";
import PropTypes from "prop-types";
import "./FilterTags.css";
import IconClose from "../../../assets/icon_close_gray.svg";
import useFilterTags from "./hooks/useFilterTags";

/**
 * 적용된 필터를 태그 형태로 표시하고, 제거 및 초기화 기능을 제공하는 컴포넌트입니다.
 * 복잡한 필터 변환 로직은 `useFilterTags` 훅으로 분리하여 가독성과 재사용성을 높였습니다.
 */
const FilterTags = ({
  filters,
  onRemoveFilter,
  onClearAll,
  categories = [],
  isMobile = false,
}) => {
  const filterTags = useFilterTags(filters, categories);

  if (filterTags.length === 0) {
    return null;
  }

  return (
    <div className={`FilterTags ${isMobile ? "FilterTags--mobile" : ""}`}>
      <div className="FilterTags-list">
        {filterTags.map((tag, index) => (
            <div key={`${tag.type}-${(tag.value && tag.value.id) || tag.value}-${index}`} className="FilterTags-tag">
            <span className="FilterTags-tag-label">{tag.label}</span>
            <button
              className="FilterTags-tag-remove"
              onClick={() => onRemoveFilter(tag.type, tag.value)}
              aria-label={`${tag.label} 필터 제거`}
            >
              <img
                src={IconClose}
                alt="삭제"
                className={"FilterTags-tag-remove-icon"}
              />
            </button>
          </div>
        ))}
        {!isMobile && (
          <button className="FilterTags-clear-all" onClick={onClearAll}>
            초기화
          </button>
        )}
      </div>
    </div>
  );
};

FilterTags.propTypes = {
  filters: PropTypes.object.isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  categories: PropTypes.array,
  isMobile: PropTypes.bool,
};

export default FilterTags;
